import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/Header.css"; // Optional for styling
import back from "../assets/images/back_arrow.png";

const Header = ({ title }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/"); // Navigate to the previous page
  };

  return (
    <header className="header">
        <img
          src={back}
          style={{ height: 20, width: 20 }}
          alt="back button"
          onClick={handleBack}
        />
        <h1 className="header-title">{title}</h1>
      </header>
  );
};

export default Header;
